import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  getProductDisplayName,
  getProductTokenCount,
  normalizeProductId,
  readNumericValue
} from "../../utils/getTokenProductUtils";

const SubscriptionProductSelect = ({
  products,
  selectedProductId,
  onSelectProduct,
  disabled
}) => {
  const { t } = useTranslation("common");

  const formatOption = (product) => {
    const name = getProductDisplayName(product);
    const tokens = getProductTokenCount(product);
    const price = readNumericValue(product.list_price, 0).toFixed(2);
    const months = readNumericValue(product.expiration_timeframe, 12);
    return `${name} — ${months} ${t("months")} · ${tokens.toLocaleString()} ${t("tokens")} / $${price}`;
  };

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-header">
        <div className="card-title">{t("Select Subscription")}</div>
      </div>
      <div className="form-group" style={{ marginBottom: 0 }}>
        <label className="form-label" htmlFor="subscriptionProductSelect">
          {t("Subscription Plan")}
        </label>
        <select
          id="subscriptionProductSelect"
          className="form-control"
          value={selectedProductId != null ? normalizeProductId(selectedProductId) : ""}
          disabled={disabled}
          onChange={(event) => onSelectProduct(event.target.value)}>
          <option value="">{t("Select a subscription plan")}</option>
          {(products || []).map((product) => (
            <option key={product.id} value={normalizeProductId(product.id)}>
              {formatOption(product)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

SubscriptionProductSelect.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  selectedProductId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelectProduct: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

SubscriptionProductSelect.defaultProps = {
  products: [],
  selectedProductId: null,
  disabled: false
};

export default SubscriptionProductSelect;
